<template>
  <div class="w-fulll footer-top border-t-2 border-white">
    <div class="container mx-auto py-8 lg:px-0 px-4">
      <div
        class="flex sm:items-center justify-around text-white sm:flex-row flex-col sm:gap-0 gap-4"
      >
        <div class="flex flex-col">
          <h4 class="font-semibold text-xl md:text-2xl">
            🔐 {{ dataLocale.data.title }}
          </h4>
          <p class="md:text-lg xl:text-xl">{{ dataLocale.data.description }}</p>
        </div>
        <a
          href="https://app.qrdove.com/sign-up"
          target="_blank"
          class="flex items-center gap-2 h-10 xs:h-[50px] w-fit px-8 flex-shrink-0 rounded-3xl bg-white text-black drop-shadow-md hover:drop-shadow-xl"
          >{{ $t("try_free_now") }}
          <ArrowRightIcon />
        </a>
      </div>
    </div>
  </div>
  <footer class="grid px-4 py-8 lg:py-16 sm:px-6 bg-white">
    <div class="mx-auto container">
      <div class="container mx-auto">
        <div class="grid gap-8 mt-4 lg:grid-cols-12">
          <div class="grid items-center gap-x-8 lg:block lg:col-span-4">
            <p>
              <IconQRDove class="w-12" />
            </p>
            <div class="mt-4 text-base xs:text-lg">
              <div class="italic">"{{ $t("footer.quote") }}"</div>
              <div class="mt-2">
                <p>{{ $t("footer.description") }}</p>
                <p class="mt-4">{{ $t("footer.trademark") }}</p>
              </div>
            </div>
          </div>
          <div class="lg:col-span-8 lg:col-start-6">
            <div
              class="grid grid-cols-1 xs:grid-cols-2 gap-10 md:-mr-12 lg:grid-col-3 md:grid-cols-3 text-base"
            >
              <div>
                <span class="font-bold text-xl text-black">
                  {{ $t("footer.tool") }}
                </span>
                <ul class="mt-3 space-y-3 md:mt-5 lg:space-y-4">
                  <li
                    class="transition text-grow hover:text-black"
                    v-for="tool in toolLocale.data"
                  >
                    <nuxt-link :to="tool.url">{{ tool.name }}</nuxt-link>
                  </li>
                </ul>
              </div>
              <div>
                <h4 class="font-bold text-xl text-black">
                  {{ $t("footer.legal") }}
                </h4>
                <ul class="mt-3 space-y-3 md:mt-5 lg:space-y-4">
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/page/cookies-policy">{{
                      $t("footer.cookie_policy")
                    }}</nuxt-link>
                  </li>
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/page/privacy-policy">{{
                      $t("footer.privacy_policy")
                    }}</nuxt-link>
                  </li>
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/page/terms-of-conditions">{{
                      $t("footer.terms")
                    }}</nuxt-link>
                  </li>
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/page/acceptable-use-policy">{{
                      $t("footer.accept")
                    }}</nuxt-link>
                  </li>
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/page/data-processing-agreenent">{{
                      $t("footer.data_process")
                    }}</nuxt-link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 class="font-bold text-xl text-black">
                  {{ $t("footer.info") }}
                </h4>
                <ul class="mt-3 space-y-3 md:mt-5 lg:space-y-4">
                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/pricing">Pricing</nuxt-link>
                  </li>

                  <li class="transition text-grow hover:text-black">
                    <nuxt-link to="/contact-us">{{
                      $t("footer.contact")
                    }}</nuxt-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-10 border-t py-6">
        <div class="grid gap-8 justify-items-center lg:grid-cols-3">
          <div class="lg:justify-self-start lg:col-span-2">
            <div
              class="flex flex-wrap justify-center -mx-4 lg:mx-0 lg:space-x-4 lg:justify-start"
            >
              <LayoutsNavigationLanguageSwitchLocaleFooter />
            </div>
          </div>
          <div class="lg:justify-self-end">
            <ul class="flex items-center space-x-6">
              <li v-for="social in socials">
                <a
                  :href="social.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  :aria-label="social.name"
                >
                  <component v-bind:is="social.icon" stroke-width="1" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="text-center block py-2">
        © {{ year }} QRDove. {{ $t("footer.all_right") }}
      </div>
    </div>
  </footer>
</template>
<script lang="ts">
import {
  ArrowRightIcon,
  BrandFacebookIcon,
  BrandTwitterIcon,
  BrandYoutubeIcon,
  BrandBehanceIcon,
  BrandLinkedinIcon,
} from "vue-tabler-icons";

import IconQRDove from "~/assets/svg/icon.svg?component";
import DataLocale from "~~/config/interface/DataLocale";
import MultiDataLocale from "~~/config/interface/MultiDataLocale";

export default defineComponent({
  components: {
    ArrowRightIcon,
    BrandFacebookIcon,
    BrandTwitterIcon,
    BrandYoutubeIcon,
    BrandBehanceIcon,
    BrandLinkedinIcon,
    IconQRDove,
  },
  setup() {
    const dataLocale = new DataLocale([
      {
        locale: "en",
        title: "Unlock the Power of QR Codes",
        description:
          "Discover versatile QR code solutions offering full customization, tracking capabilities, and more.",
      },
      {
        locale: "fr",
        title: "Débloquez la puissance des codes QR",
        description:
          "Découvrez des solutions de codes QR polyvalentes offrant une personnalisation complète, des capacités de suivi, et bien plus encore.",
      },
      {
        locale: "it",
        title: "Sblocca la potenza dei codici QR",
        description:
          "Scopri soluzioni di codici QR versatili che offrono completa personalizzazione, capacità di tracciamento e altro ancora.",
      },
      {
        locale: "de",
        title: "Entfesseln Sie die Kraft von QR-Codes",
        description:
          "Entdecken Sie vielseitige QR-Code-Lösungen, die vollständige Anpassungsmöglichkeiten, Tracking-Funktionen und mehr bieten.",
      },
      {
        locale: "es",
        title: "Desbloquea el poder de los códigos QR",
        description:
          "Descubre soluciones versátiles de códigos QR que ofrecen personalización completa, capacidades de seguimiento y más.",
      },
      {
        locale: "nl",
        title: "Ontgrendel de kracht van QR-codes",
        description:
          "Ontdek veelzijdige QR-codeoplossingen die volledige aanpassingsmogelijkheden, trackingfuncties en meer bieden.",
      },
      {
        locale: "pt",
        title: "Desbloqueie o Poder dos Códigos QR",
        description:
          "Descubra soluções versáteis de código QR que oferecem personalização completa, capacidades de rastreamento e muito mais.",
      },
      {
        locale: "ja",
        title: "QRコードの力を解き放つ",
        description:
          "フルカスタマイズ、追跡機能などを備えた多用途なQRコードソリューションをご覧ください。",
      },
      {
        locale: "zh",
        title: "解锁二维码的力量",
        description: "探索提供完整自定义、跟踪功能等的多功能二维码解决方案。",
      },
      {
        locale: "vi",
        title: "Mở khóa Sức mạnh của Mã QR",
        description:
          "Khám phá các giải pháp mã QR đa năng cung cấp khả năng tùy chỉnh hoàn toàn, khả năng theo dõi và hơn thế nữa.",
      },
      {
        locale: "id",
        title: "Buka Kekuatan Kode QR",
        description:
          "Temukan solusi kode QR serbaguna yang menawarkan penyesuaian penuh, kemampuan pelacakan, dan banyak lagi.",
      },
      {
        locale: "tr",
        title: "QR Kodlarının Gücünün Kilidini Açın",
        description:
          "Tam özelleştirme, takip yetenekleri ve daha fazlasını sunan çok yönlü QR kodu çözümlerini keşfedin.",
      },
      {
        locale: "hi",
        title: "QR कोड की शक्ति को अनलॉक करें",
        description:
          "पूर्ण अनुकूलन, ट्रैकिंग क्षमताओं और अधिक की पेशकश करने वाले बहुमुखी QR कोड समाधानों की खोज करें।",
      },
      {
        locale: "th",
        title: "ปลดล็อกพลังของคิวอาร์โค้ด",
        description:
          "ค้นพบโซลูชันคิวอาร์โค้ดที่หลากหลายซึ่งนำเสนอการปรับแต่งอย่างเต็มรูปแบบ ความสามารถในการติดตาม และอื่นๆ อีกมากมาย",
      },
    ]);
    const toolLocale = new MultiDataLocale([
      {
        locale: "en",
        data: [
          {
            name: "Text to QR Code",
            url: "/",
          },
          {
            name: "Url to QR Code",
            url: "/url",
          },
          {
            name: "Multimedia to QR Code",
            url: "/multimedia",
          },
          {
            name: "Document to QR Code",
            url: "/document",
          },
          {
            name: "Scan QR Code",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "vi",
        data: [
          {
            name: "Chuyển đổi văn bản thành mã QR",
            url: "/",
          },
          {
            name: "Chuyển đổi đường dẫn URL thành mã QR",
            url: "/url",
          },
          {
            name: "Chuyển đổi multimedia thành mã QR",
            url: "/multimedia",
          },
          {
            name: "Chuyển đổi tài liệu thành mã QR",
            url: "/document",
          },
          {
            name: "Quét mã QR",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "de",
        data: [
          {
            name: "Text zu QR-Code",
            url: "/",
          },
          {
            name: "URL zu QR-Code",
            url: "/url",
          },
          {
            name: "Multimedia zu QR-Code",
            url: "/multimedia",
          },
          {
            name: "Dokument zu QR-Code",
            url: "/document",
          },
          {
            name: "QR-Code scannen",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "fr",
        data: [
          {
            name: "Texte en code QR",
            url: "/",
          },
          {
            name: "URL en code QR",
            url: "/url",
          },
          {
            name: "Multimédia en code QR",
            url: "/multimedia",
          },
          {
            name: "Document en code QR",
            url: "/document",
          },
          {
            name: "Scanner le code QR",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "es",
        data: [
          {
            name: "Texto a código QR",
            url: "/",
          },
          {
            name: "URL a código QR",
            url: "/url",
          },
          {
            name: "Multimedia a código QR",
            url: "/multimedia",
          },
          {
            name: "Documento a código QR",
            url: "/document",
          },
          {
            name: "Escanear código QR",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "it",
        data: [
          {
            name: "Testo in codice QR",
            url: "/",
          },
          {
            name: "URL in codice QR",
            url: "/url",
          },
          {
            name: "Multimedia in codice QR",
            url: "/multimedia",
          },
          {
            name: "Documento in codice QR",
            url: "/document",
          },
          {
            name: "Scansione codice QR",
            url: "/qr-code-scanner",
          },
        ],
      },

      {
        locale: "nl",
        data: [
          {
            name: "Tekst naar QR-code",
            url: "/",
          },
          {
            name: "URL naar QR-code",
            url: "/url",
          },
          {
            name: "Multimedia naar QR-code",
            url: "/multimedia",
          },
          {
            name: "Document naar QR-code",
            url: "/document",
          },
          {
            name: "QR-code scannen",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "pt",
        data: [
          {
            name: "Texto para código QR",
            url: "/",
          },
          {
            name: "URL para código QR",
            url: "/url",
          },
          {
            name: "Multimídia para código QR",
            url: "/multimedia",
          },
          {
            name: "Documento para código QR",
            url: "/document",
          },
          {
            name: "Digitalizar código QR",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "zh",
        data: [
          {
            name: "文本转QR码",
            url: "/",
          },
          {
            name: "URL转QR码",
            url: "/url",
          },
          {
            name: "多媒体转QR码",
            url: "/multimedia",
          },
          {
            name: "文档转QR码",
            url: "/document",
          },
          {
            name: "扫描QR码",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "ja",
        data: [
          {
            name: "テキストをQRコードに変換",
            url: "/",
          },
          {
            name: "URLをQRコードに変換",
            url: "/url",
          },
          {
            name: "マルチメディアをQRコードに変換",
            url: "/multimedia",
          },
          {
            name: "ドキュメントをQRコードに変換",
            url: "/document",
          },
          {
            name: "QRコードをスキャン",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "id",
        data: [
          {
            name: "Teks ke QR Code",
            url: "/",
          },
          {
            name: "URL ke QR Code",
            url: "/url",
          },
          {
            name: "Multimedia ke QR Code",
            url: "/multimedia",
          },
          {
            name: "Dokumen ke QR Code",
            url: "/document",
          },
          {
            name: "Pindai QR Code",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "tr",
        data: [
          {
            name: "Metin QR Kodu'na",
            url: "/",
          },
          {
            name: "URL QR Kodu'na",
            url: "/url",
          },
          {
            name: "Multimedya QR Kodu'na",
            url: "/multimedia",
          },
          {
            name: "Belge QR Kodu'na",
            url: "/document",
          },
          {
            name: "QR Kodu Tarayıcı",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "hi",
        data: [
          {
            name: "QR कोड के लिए टेक्स्ट",
            url: "/",
          },
          {
            name: "URL से QR कोड",
            url: "/url",
          },
          {
            name: "मल्टीमीडिया से QR कोड",
            url: "/multimedia",
          },
          {
            name: "डॉक्यूमेंट से QR कोड",
            url: "/document",
          },
          {
            name: "QR कोड स्कैन करें",
            url: "/qr-code-scanner",
          },
        ],
      },
      {
        locale: "th",
        data: [
          {
            name: "ข้อความเป็น QR Code",
            url: "/",
          },
          {
            name: "URL เป็น QR Code",
            url: "/url",
          },
          {
            name: "มัลติมีเดียเป็น QR Code",
            url: "/multimedia",
          },
          {
            name: "เอกสารเป็น QR Code",
            url: "/document",
          },
          {
            name: "สแกน QR Code",
            url: "/qr-code-scanner",
          },
        ],
      },
    ]);
    return {
      dataLocale,
      toolLocale,
      year: ref(new Date().getFullYear()),
      socials: ref([
        {
          icon: "BrandFacebookIcon",
          link: "https://www.facebook.com/qrdove",
          name: "QRDove on facebook",
        },
        {
          icon: "BrandTwitterIcon",
          link: "https://twitter.com/qrdove",
          name: "QRDove on twitter",
        },
        {
          icon: "BrandYoutubeIcon",
          link: "https://www.youtube.com/c/qrdove",
          name: "QRDove on youtube",
        },
        {
          icon: "BrandLinkedinIcon",
          link: "https://www.linkedin.com/company/qrdove",
          name: "QRDove on linkedin",
        },
      ]),
    };
  },
});
</script>
<style lang="scss">
.footer-top {
  width: 100%;
  background-color: var(--success);
  background-position: bottom;
  background-repeat: repeat;
  background-image: url(/images/bg_pattern.png) !important;
}
</style>
